import { FunctionComponent, PropsWithChildren } from 'react';
import cn from 'classnames';

import './style.scss';
import { ClassNameProps } from '../../common/model';

export const ContentWrapper: FunctionComponent<PropsWithChildren<ClassNameProps>> = ({ children, className }) => {
    return <div className={cn('content-wrapper', className)}>{children}</div>;
};
